import { AgGridReact } from 'ag-grid-react';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCampaignList,
  getCampaignMemberStatus,
  getGenericMasterFilteredListByKey,
  getGridDataByModuleKey,
  getLeadList,
  getleadTotalCount,
} from '../../../../redux/selector';
import {
  fetchDataAndUpdateStore,
  fetchLeadsAndAppendToModule,
  fetchProductsAndAppendToModule,
  fetchRemainingData,
} from '../../../../redux/actions';
import Select from 'react-select';
import apiServices from '../../../../services/service';
import { toast } from 'react-toastify';
import {
  campaignInputData,
  handleGridSearch,
  leadInputData,
  productInputData,
} from '../../../../shared/constants';
import CustomPagination from '../../grid/customPagination';

import { Form, Formik } from 'formik';
import useCommonProductColumnDefs from './useCommonProductColumnDefs';
import { DateBox, TextBox } from '../../../../shared/controls/form';

const CommonProductList = ({
  module,
  localData,
  hasUpdateLeadPermission,
  handleCallbackGetList,
}) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [showPopup2, setShowPopup2] = useState(false);
  const [showDeletePopup, setDeletePopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState([]);
  const [selectedRows, setSelectedRows] = useState(null);
  const [selectedRowsPopup, setSelectedRowsPopup] = useState([]);
  const gridRef = useRef();
  const [selectedOptions, setSelectedOptions] = useState({});
  const [deleteData, setDeleteData] = useState([]);
  const [editData, setEditData] = useState([]);
  const [filteredLeadList, setFilteredLeadList] = useState([]);
  const localGridRef = useRef();
  const [selectAll, setSelectAll] = useState(false);

  const gridApiRef = useRef(null);
  const [localLeadInputPayload, setLocalLeadInputPayload] = useState({
    ...productInputData,
  });
  // Pagination state
  const [totalCount, setTotalCount] = useState(0);
  const gridData = useSelector(getGridDataByModuleKey('productList'));
  const [searchText, setSearchText] = useState(gridData?.inputPayload?.searchText || '');
  const [isFocused, setIsFocused] = useState(false);
  const [getSeletedIds, setSeletedIds] = useState([]);
  
  const [leadListAll, setLeadListAll] = useState(null);

  // When grid is ready, capture the API and update pagination info
  const onGridReady = (params) => {
    gridApiRef.current = params.api;
  };

  const onSelectionChanged = (event) => {
    setSelectedRows(event.api.getSelectedRows()); // Get all selected rows
  };

  const onSelectionChangedPopup = (event) => {
    setSelectedRowsPopup(event.api.getSelectedRows()); // Get all selected rows
    const selectedRows = gridRef.current.api.getSelectedRows();
    const selectedIds = selectedRows.map((row) => row.id);
    setSeletedIds(selectedIds);
  };


  useEffect(() => {
    fetchCampaign();
  }, [localLeadInputPayload.pageNumber, localLeadInputPayload?.pageSize, localData?.id]);

  const memberStatus = useSelector(getGenericMasterFilteredListByKey('MemberStatusCrm'));

  const campaignList = useSelector(getCampaignList);

  const fetchCampaign = async () => {
    if (!localData?.id) return;
    if (searchText) {
      localLeadInputPayload.searchText = searchText;
    } else {
      localLeadInputPayload.searchText = null;
    }
    gridApiRef.current?.showLoadingOverlay();
    setLoading(true);

    try {
      const res = await apiServices.getProductList(localLeadInputPayload);
      const leads = res.data.product || [];

      setLeadListAll(leads);
      setTotalCount(res.data.totalCount || 0);

      if (leads.length === 0) {
        gridApiRef.current?.showNoRowsOverlay();
      } else {
        gridApiRef.current?.hideOverlay();
      }
    } catch (error) {
      console.error('Error fetching campaigns', error);
      gridApiRef.current?.showNoRowsOverlay();
    } finally {
      setLoading(false);
    }
  };

  const campaignColumnDefs = [
    {
      headerName: 'Product',
      field: 'name',
      width: 150,
      filter: 'agSetColumnFilter',
      headerCheckboxSelection: true,
      checkboxSelection: true,
    },
    {
      headerName: 'Vendor Name',
      field: 'vendorName',
      width: 150,
      filter: 'agSetColumnFilter',
    },

    // {
    //   headerName: 'Discount',
    //   field: 'discount',
    //   width: 150,
    //   filter: 'agSetColumnFilter',
    // },
    {
      headerName: 'Tax',
      field: 'tax',
      width: 150,
      filter: 'agSetColumnFilter',
    },
    {
      headerName: 'List Price',
      field: 'listPrice',
      width: 150,
      filter: 'agSetColumnFilter',
      editable: true,
      cellEditor: 'agTextCellEditor',
    },
    // { headerName: "Email Opt Out", field: "emailOptOut", width: 150, filter: "agSetColumnFilter" },
  ];

  const clearSearch = async () => {
    setSearchText('');

    const payload = {
      ...localLeadInputPayload,
      pageNumber: 1,
      searchText: '',
    };

    try {
      gridApiRef.current?.showLoadingOverlay(); // ✅ Show loading before fetch
      setLoading(true);
      const res = await apiServices.getProductList(payload);
      const leads = res.data.product || [];

      setLeadListAll(leads);
      setTotalCount(res.data.totalCount || 0);

      if (leads.length === 0) {
        gridApiRef.current?.showNoRowsOverlay();
      } else {
        gridApiRef.current?.hideOverlay();
      }
    } catch (error) {
      console.error('Search Clear Error', error);
      gridApiRef.current?.showNoRowsOverlay();
    } finally {
      setLoading(false);
    }
  };
  const handleClickEdit = (data) => {
    setShowPopup2(true);
    setEditData({
      ...data,
      type: 'edit',
    });
  };

  // Function to open the third popup
  const openDeletePopup = (data) => {
    setDeletePopup(true);
    setDeleteData(data);
  };

  const localLeadColumnDefs = useCommonProductColumnDefs({ handleClickEdit, openDeletePopup });

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          minWidth: 225,
          width: 225,
          maxWidth: 225,
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
      position: 'left',
      defaultToolPanel: 'none', //show off filter tab bydefault.
    };
  }, []);

  const statusBar = useMemo(() => {
    return {
      statusPanels: [
        {
          statusPanel: () => (
            <CustomPagination
              inputPayload={localLeadInputPayload}
              setInputPayload={setLocalLeadInputPayload}
              totalCount={totalCount}
            />
          ),
          align: 'center',
        },
      ],
    };
  }, [localLeadInputPayload, totalCount]);

  const onSearch = (searchValue) => {
    handleGridSearch({
      searchValue,
      apiMethod: apiServices.getProductList,
      gridApiRef,
      inputPayload: localLeadInputPayload,
      setData: setLeadListAll,
      setTotalCount,
      setLoading,
    });
  };

  const onFilterTextBoxChangedLocal = useCallback(() => {
    localGridRef.current.api.setQuickFilter(document.getElementById('filter-text-box').value);
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const trimmedText = searchText.trim();
      if (trimmedText) {
        onSearch(trimmedText);
      } else {
        clearSearch(); // <--- this ensures it resets with empty searchText
      }
    }
  };

  const frameworkComponents = {
    checkboxRenderer: (props) => {
      const handleChange = (e) => {
        const isSelected = props.node.isSelected();
        props.node.setSelected(!isSelected); // Toggle the selection state of the row
      };

      return <input type="checkbox" checked={props.node.isSelected()} onChange={handleChange} />;
    },
  };

  const handleOpen = () => {
    setIsOpen(true);
    fetchCampaign();
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const openPopup2 = () => {
    setShowPopup2(true);
  };

  const closePopup2 = () => {
    setShowPopup2(false);
  };
  // Function to close the third popup
  const closeDeletePopup = () => {
    setDeletePopup(false);
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;

    const updatedFormData = {
      ...formData,
      [name]: selectedId,
      [`${name}Name`]: selectedValue,
    };
    if (name === 'memberStatusId') {
      setFormData({
        ...formData,
        memberStatusId: selectedValue,
        memberStatus: selectedId,
      });
    }
  };

  // const handleSubmit = async () => {
  //   setLoading(true);
  //   const selectedIds = selectedRowsPopup.map((row) => row.id);
  //   const productId = selectedIds.join(",");
  //   //   const requests = selectedRowsPopup.map((row) => {
  //   // const matchedRow = formData.find((item) => item.id === row.id);
  //   // if (formData.type === "edit") {
  //   //   const data = {
  //   //     ...formData,
  //   //     moduleId: formData.id,
  //   //     campaignId: localData.id,
  //   //     module: "Lead",
  //   //   };

  //   //   await apiServices
  //   //     .updateCampaignByModule(data)
  //   //     .then((response) => {
  //   //       if (response.status === 200) {
  //   //         setShowPopup2(false);
  //   //         dispatch(
  //   //           fetchLeadsAndAppendToModule({
  //   //             moduleName: module,
  //   //             id: localData?.id,
  //   //           })
  //   //         );

  //   //         toast.success("Lead Updated Successfully!", {
  //   //           position: "top-right",
  //   //         });
  //   //       }
  //   //     })
  //   //     .catch((error) => {
  //   //       console.error("Error updating leads:", error);
  //   //       toast.error("Failed to update leads.", { position: "top-right" });
  //   //     });
  //   // } else {
  //   const selectedRow = selectedRowsPopup[0]; // Use only the first selected row
  //   const matchedRow = formData?.find((item) => item?.id === selectedRow?.id);
  //   const data = {
  //     productId: productId,
  //     priceSheetId: localData.id,
  //     listPrice: matchedRow?.listPrice ?? 0,
  //     currencyPrice: formData?.currencyPrice ?? "USD", // or use a default like "INR"
  //   };

  //   await apiServices
  //     .productPricesheetAssociation(data)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         setSelectedRowsPopup([]);
  //         handleClose();
  //         handleCallbackGetList();
  //         // dispatch(
  //         //   fetchLeadsAndAppendToModule({
  //         //     moduleName: module,
  //         //     id: localData?.id,
  //         //   })
  //         // );

  //         toast.success("Product Added Successfully!", {
  //           position: "top-right",
  //         });
  //       }
  //   })
  //   .catch((error) => {
  //     console.error("Error adding product:", error);
  //     toast.error("Failed to add product.", { position: "top-right" });
  //   });

  //   setLoading(false);
  //   setFormData([]);
  // };

  const handleSubmit = async (formData) => {
    setLoading(true);
    if (formData.type === 'edit') {
      const data = {
        ...formData,
        id: formData.id,
        productId: formData?.productId,
        priceSheetId: formData?.priceSheetId,
        listPrice: formData?.listPrice,
      };

      await apiServices
        .updateProductPriceSheetAssociation(data)
        .then((response) => {
          if (response.status === 200) {
            setShowPopup2(false);
            dispatch(
              fetchProductsAndAppendToModule({
                moduleName: module,
                id: localData?.id,
              })
            );

            toast.success('Lead Updated Successfully!', {
              position: 'top-right',
            });
          }
        })
        .catch((error) => {
          console.error('Error updating leads:', error);
          toast.error('Failed to update leads.', { position: 'top-right' });
        });
    } else {
      const addedProductReq = {
        addProductPriceSheetAssociationRequest: getSeletedIds.map((id) => ({
          productId: id,
          priceSheetId: localData.id,
          listPrice: formData.find((item) => item.id === id)?.listPrice ?? 0,
          currencyPrice: formData?.currencyPrice ?? 'USD',
        })),
      };

      await apiServices
        .productPricesheetAssociation(addedProductReq)
        .then((response) => {
          if (response.status === 200) {
            setSelectedRowsPopup([]);
            handleClose();
            dispatch(
              fetchProductsAndAppendToModule({
                moduleName: 'PriceSheet',
                id: localData?.id,
              })
            );
            toast.success('Product Added Successfully!', {
              position: 'top-right',
            });
          }
        })
        .catch((error) => {
          console.error('Error adding product:', error);
          toast.error('Failed to add product.', { position: 'top-right' });
        });
    }

    setLoading(false);
    setFormData([]);
  };

  const handleClickDeleteLead = (paramsValue) => {
    setLoading(true);
    const selectedIds = selectedRows?.map((row) => row.id);
    // Creating the desired JSON object
    const data = {
      id: selectedRows?.length > 0 ? selectedIds : [paramsValue?.id],
    };
    apiServices
      .deletePricesheetFromProduct(data)
      .then((response) => {
        if (response.status === 200) {
          setDeletePopup(false);
          setSelectedRows([]);
          dispatch(
            fetchProductsAndAppendToModule({
              moduleName: 'PriceSheet',
              id: localData?.id,
            })
          );
          setLoading(false);
          toast.success('Product UnAssigned Successfully!', {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        console.error('Error while UnAssigning Product:', error);
        setLoading(false);
      });
  };

  const handleChangeEditForm = (e) => {
    const { name, value } = e.target;
    let convertedValue = value;

    if (name === 'listPrice') {
      if (value.trim() === '') {
        convertedValue = null;
      } else {
        convertedValue = value.replace(/[^0-9]/g, '');
        if (convertedValue !== '') {
          convertedValue = parseInt(convertedValue, 10);
        }
      }
    }

    // // Clear the error for this field
    // setErrorMsg((prev) => ({
    //   ...prev,
    //   [name]: undefined,
    // }));

    // Update form data
    setEditData((prev) => ({
      ...prev,
      [name]: convertedValue,
    }));

    // setFormEdited(true);
  };

  const handleChangeForm = (updatedRow, rowIndex, changeFrom) => {
    setFormData((prev) => {
      const existingIndex = prev.findIndex((item) => item.id === updatedRow.id);

      if (existingIndex !== -1) {
        // Update existing entry
        const updatedFormData = [...prev];
        updatedFormData[existingIndex] = {
          ...updatedFormData[existingIndex],
          listPrice: updatedRow.listPrice,
        };
        return updatedFormData;
      } else {
        // Add new entry
        return [
          ...prev,
          {
            id: updatedRow.id,
            listPrice: updatedRow.listPrice,
            currencyPrice: updatedRow.currencyPrice ?? 'USD', // optional
          },
        ];
      }
    });
  };

  // const handleChangeForm = (e, rowIndex, changeFrom) => {
  //   if (changeFrom !== "SalesOrderd") {
  //     const { name, value } = e.target;
  //     const convertedValue = value;
  //     setFormData({
  //       ...formData,
  //       [name]: convertedValue,
  //     });
  //   }

  //   setFormData((prev) => {
  //     const updatedItems = [...prev.saleOrderDetails];
  //     const updatedRow = { ...updatedItems[rowIndex] };
  //     const quantity = Number(updatedRow.quantity) || 0;
  //     const listPrice = Number(updatedRow.listPrice) || 0;
  //     const discount = Number(updatedRow.discountPercent) || 0;
  //     const tax = Number(updatedRow.taxPercent) || 0;

  //     const amount = quantity * listPrice;
  //     const discountAmount = (amount * discount) / 100;
  //     const taxAmount = (amount * tax) / 100;
  //     const lineTotal = amount - discountAmount + taxAmount;
  //     updatedRow.amount = amount;
  //     updatedRow.lineTotal = lineTotal;

  //     updatedItems[rowIndex] = updatedRow;

  //     const updatedWithLineNumbers = updatedItems.map((item, index) => ({
  //       ...item,
  //       lineNumber: index + 1,
  //     }));

  //     return {
  //       ...prev,
  //       listPrice: updatedWithLineNumbers,

  //     };
  //   });
  // };

  return (
    <div className="row">
      <div className="col-12 col-sm-12 col-md-12">
        <div className="infoBox">
          <div className="addlead-header">
            <label htmlFor="" className="flex-div align-items-center">
              <img className="me-2" src="../assets/images/leadInfo.svg" alt="" />
              Products({localData?.productAssociations?.length})
            </label>

            <span></span>

            <button type="button" className="btn btn-outline-primary attBtn" onClick={handleOpen}>
              Add Product
            </button>
          </div>
          <div className="leadcontent">
            <>
              <div className="row">
                <div className="col-12 col-md-12">
                  <div id="view_leadtable">
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div className="heading_item">
                        <input
                          className="form-control"
                          id="filter-text-box"
                          type="Text"
                          placeholder="Search in Products..."
                          onInput={onFilterTextBoxChangedLocal}
                        />
                      </div>
                      {selectedRows?.length > 0 && (
                        <div className="heading_item">
                          <button
                            className="btn btn-primary"
                            type="button"
                            onClick={handleClickDeleteLead}
                          >
                            UnAssign
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="cutome_ag_theme " style={{ marginTop: '1rem' }} id="withFilter">
                      <div className="ag-theme-balham tbl_height">
                        <AgGridReact
                          rowData={localData?.productAssociations}
                          columnDefs={localLeadColumnDefs}
                          defaultColDef={{
                            flex: 1,
                            minWidth: 100,
                            resizable: true,
                          }}
                          suppressRowClickSelection={true}
                          rowSelection="multiple"
                          // sideBar={sideBar}
                          onSelectionChanged={onSelectionChanged}
                          alwaysShowVerticalScroll={true}
                          ref={localGridRef}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>
          {isOpen && (
            <div id="genricPopup">
              <div className="popup-backdrop">
                <div className="popup fullWidthPopup">
                  {/* Popup Header */}
                  <div className="popup-header">
                    <h4 className="popup-title">Add Product to PriceSheet : {localData?.name}</h4>
                    <button className="custom-btn-close" onClick={handleClose}></button>
                  </div>
                  {/* Popup Body */}
                  <div className="popup-body">
                    <div className="popupbody_header">
                      <div className="hd_leftview">
                        <div className="heading_item" id="contct_search">
                          <div className="search-container">
                            <input
                              type="text"
                              id="filter-text-box"
                              className={`form-control${searchText ? ' focused' : ''}`}
                              placeholder="Search..."
                              value={searchText}
                              onChange={(e) => setSearchText(e.target.value)}
                              onKeyDown={handleKeyDown}
                            />

                            {searchText && (
                              <span className="clear-btn" onClick={clearSearch}>
                                &times;
                              </span>
                            )}
                            <button
                              className="contactsearch"
                              type="button"
                              onClick={() => onSearch(searchText)}
                              onFocus={() => setIsFocused(true)}
                              onBlur={() => setIsFocused(false)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <circle cx="11" cy="11" r="8"></circle>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                              </svg>
                            </button>
                          </div>
                        </div>
                        <div className="flx_heding view_fnt" id="action_dropdown"></div>
                      </div>
                      <div className="hd_rightview" id="update_campaign">
                        <div className="flx_heding view_fnt">
                          <label>
                            Total Records: <span>{totalCount}</span>
                          </label>
                        </div>

                        <span className="separator"></span>
                        <div className="flx_heding">
                          <button
                            className="add-btn"
                            type="button"
                            onClick={() => handleSubmit(formData)}
                            disabled={selectedRowsPopup.length === 0 || loading}
                            style={{ marginTop: '1rem' }}
                          >
                            {selectedRowsPopup.length > 0 && loading ? (
                              <>
                                <div
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                ></div>
                                Loading...
                              </>
                            ) : (
                              'Add to Product'
                            )}
                          </button>
                        </div>

                        {/* Popup 2 Overlay */}
                      </div>
                    </div>
                    <div className="cutome_ag_theme" style={{ marginTop: '1rem' }}>
                      <div
                        className="ag-theme-balham tbl_height"
                        style={{
                          height: 'calc(100vh - 320px)',
                          width: '100%',
                        }}
                      >
                        <AgGridReact
                          rowData={leadListAll}
                          columnDefs={campaignColumnDefs}
                          suppressRowClickSelection={true}
                          defaultColDef={{
                            flex: 1,
                            minWidth: 100,
                            resizable: true,
                          }}
                          sideBar={sideBar}
                          rowSelection="multiple"
                          onSelectionChanged={onSelectionChangedPopup}
                          ref={gridRef}
                          statusBar={statusBar}
                          onGridReady={onGridReady}
                          stopEditingWhenCellsLoseFocus={true}
                          singleClickEdit={true}
                          onCellValueChanged={(params) => {
                            handleChangeForm(params.data, params.node.rowIndex, 'SalesOrderd');
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showPopup2 && (
            <div id="genricPopup">
              <div className="popup-backdrop">
                <div className="popup-overlay">
                  <div className="popup" style={{ width: '50%' }}>
                    {/* Popup Header */}
                    <div className="popup-header">
                      <h4 className="popup-title">Update Product</h4>
                      <button className="custom-btn-close" onClick={closePopup2}></button>
                    </div>

                    {/* Popup Body */}
                    <div className="popup-body" style={{ color: '#000', zIndex: '1050' }}>
                      <div className="row">
                        <div className="col-12 col-md-12">
                          <Formik>
                            <Form>
                              <div className="input-container">
                                <TextBox
                                  label={'List Price'}
                                  name={'listPrice'}
                                  handleChange={handleChangeEditForm}
                                  value={editData?.listPrice ?? ''}
                                  placeholder={'Enter List Price'}
                                />
                              </div>
                              {/* <div className="input-container">
                                  <DateBox
                                  label={"Support Start Date"}
                                  name={'supportStartDate'}
                                  handleChange={handleChangeEditForm}
                                  value={editData?.supportStartDate ?? ''}
                                  />
                                  </div>
                                  <div className="input-container">
                                  <DateBox
                                  label={"Support End Date"}
                                  name={'supportEndDate'}
                                  handleChange={handleChangeEditForm}
                                  value={editData?.supportEndDate ?? ''}
                                  />
                                  </div> */}
                            </Form>
                          </Formik>
                        </div>
                      </div>
                    </div>

                    {/* Popup Footer */}
                    <div className="popup-footer" id="unassign-popup">
                      <button className="cancel-lead ld-btn" onClick={closePopup2}>
                        Cancel
                      </button>
                      <button
                        className="save-lead ld-btn"
                        onClick={() =>
                          handleSubmit({
                            id: editData.id,
                            productId: editData?.productId,
                            priceSheetId: editData?.priceSheetId,
                            listPrice: editData?.listPrice,
                            type: 'edit',
                          })
                        }
                      >
                        Save
                      </button>

                      {/* Popup 3 Overlay */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showDeletePopup && (
            <div id="unassign-popup">
              <div className="popup-overlay">
                <div
                  className="popup"
                  style={{
                    width: '50%',
                    textAlign: 'center',
                    padding: '20px',
                    zIndex: '9999',
                    background: 'white',
                  }}
                >
                  {/* Popup Body */}
                  <div className="popup-body">
                    <div className="row">
                      <div className="col-12 col-md-12">
                        <div className="unassign-txt">
                          <p>
                            Unassign {deleteData?.productName} from {localData?.name}?
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Popup Footer */}
                  <div className="unassign-footer">
                    <button className="btn btn-outline-primary" onClick={closeDeletePopup}>
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={() => handleClickDeleteLead(deleteData)}
                      disabled={loading}
                    >
                      {loading && (
                        <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                      )}
                      {loading ? 'Loading...' : 'Unassign'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommonProductList;
